import { render, staticRenderFns } from "./StaffDetails.vue?vue&type=template&id=7b52f278&scoped=true&"
import script from "./StaffDetails.vue?vue&type=script&lang=js&"
export * from "./StaffDetails.vue?vue&type=script&lang=js&"
import style0 from "./StaffDetails.vue?vue&type=style&index=0&id=7b52f278&scoped=true&lang=css&"
import style1 from "./StaffDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b52f278",
  null
  
)

export default component.exports